var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.refreshList}},[_c('v-icon',[_vm._v("mdi-refresh")]),_vm._v("\n  刷新\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }